var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ads-view',{attrs:{"title":_vm.$t(_vm.translation + '.ads_on_approval'),"props-headers":_vm.tableHeader,"props-filter":{
        'ad_statuses': 'Čeka na odobrenje'
    }}})
}
var staticRenderFns = []

export { render, staticRenderFns }